import { inject, Injectable } from '@angular/core';
import {
  CustomerOnboardingService,
  RegisterAWSErrorCode,
  RegisterAWSRequest,
} from '../openapi';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RegisterService {
  private register = inject(CustomerOnboardingService);
  private xTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  constructor() {}

  registerAWS(registerAWSRequest: RegisterAWSRequest) {
    // const mockResult = {
    //   Code: RegisterAWSErrorCode.AwsUserAlreadyRegistered,
    //   InvalidValues: [''],
    // };
    // return throwError(() => mockResult);
    return this.register.apiV3CustomerOnboardingRegisterAWSPost(
      this.xTimeZone,
      registerAWSRequest
    );
  }
}
